export const generalPageStepNumber = 0;
export const questionsPageStepNumber = 1;
